var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramTransIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8064 0.436249C12.8064 0.436249 14.1015 -0.0687513 13.9936 1.15768C13.9576 1.66269 13.6339 3.43018 13.382 5.34198L12.5186 11.0052C12.5186 11.0052 12.4467 11.8349 11.7991 11.9792C11.1516 12.1234 10.1803 11.4742 10.0004 11.3299C9.85647 11.2217 7.30227 9.59842 6.40287 8.80485C6.15103 8.58842 5.86323 8.15555 6.43883 7.65055L10.2162 4.04342C10.6479 3.61055 11.0796 2.60055 9.28087 3.82698L4.24437 7.25379C4.24437 7.25379 3.66877 7.61449 2.58953 7.28985L0.25114 6.56842C0.25114 6.56842 -0.612263 6.02735 0.862717 5.48625C4.46023 3.79088 8.88517 2.05945 12.8064 0.436249Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramTransIcon);
export default __webpack_public_path__ + "static/media/telegram-trans-icon.4300ab6edd24ea4179a0f7d3cf9698f5.svg";
export { ForwardRef as ReactComponent };